(() => {
  const initBeforeAndAfter = () => {
    const containers = document.querySelectorAll('.before-and-after:not([data-initialized="true"])');

    containers.forEach(container => {
      container.setAttribute('data-initialized', 'true');

      const wrapper = container.closest('.before-and-after-wrapper');
      if (!wrapper) return; 

      const tabs = wrapper.querySelectorAll('.before-and-after__tab');

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          tabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');
          container.setAttribute('data-mobile-view', tab.dataset.tab);
        });
      });
      
      const slider = container.querySelector('.before-and-after__slider');
      if (!slider) return;

      let isDragging = false;
      let animationFrameId = null;

      const updateSliderPosition = (e) => {
        if (!isDragging) return;
        
        if (animationFrameId) cancelAnimationFrame(animationFrameId);
        
        animationFrameId = requestAnimationFrame(() => {
          const rect = container.getBoundingClientRect();
          const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
          
          const xPos = Math.max(0, Math.min(clientX - rect.left, rect.width));
          const percentage = (xPos / rect.width) * 100;
          
          container.style.setProperty('--position', `${percentage}%`);
        });
      };

      slider.addEventListener('mousedown', () => {
        isDragging = true;
      });

      window.addEventListener('mouseup', () => {
        isDragging = false;
      });
      
      window.addEventListener('mousemove', updateSliderPosition);

      slider.addEventListener('touchstart', (e) => {
        e.preventDefault(); 
        isDragging = true;
      }, { passive: false });

      window.addEventListener('touchend', () => {
        isDragging = false;
      });
      
      window.addEventListener('touchmove', updateSliderPosition, { passive: false });
    });
  };

  document.addEventListener('DOMContentLoaded', initBeforeAndAfter);
  document.addEventListener('shopify:section:load', initBeforeAndAfter);
})();